<template>
    <div>
        <div class="products-banner about-jumbo">
            <div class="container">
                <div class="row">
                    <div class="col-lg-6">
                        <h1 class="white">About Me</h1>
                        <p class="white no-bottom">I've had a passion for aircraft since I was a teenager. Now I use that passion to help families all across southern Ontario.
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div class="container section-padding">
            <div class="row">
                <div class="col-lg-12">
                    <img src="@/assets/img/homepage-about.jpg" class="img-fluid float-right" />
                    <h2 class="space-bottom">Estates and Consignment Since 2005</h2>
                    <p>
                        I grew up on a tobacco farm, learning to repair machinery with my father’s guidance. We lived in
                        several small farming communities in southern Ontario over the years as we bought and sold
                        farms. I am now happily retired.
                    </p>
                    <p>
                        I began flying free flight and control line as a teenager. Fast forward several years and I
                        joined the Model Aeronautics Association of Canada in 1980. I now fly radio control and love to
                        build.
                    </p>
                    <p>
                        My aircraft vary. Some fast, others slow, scale and non. I pretty much enjoy flying
                        anything with an internal combustion engine. IMAC style of flying has taught me the most, it is
                        a very disciplined type of flying and a lot of fun. 
                    </p>
                   
                    <img src="@/assets/img/homepage-contact.jpg" class="img-fluid float-left" />
                    <p class="space-top">
                        Engine collecting is something else I really
                        enjoy and the diesel engines have always intrigued me. Indoor flying is a great way to learn new
                        manoeuvers and fly in small air space, I prefer it over simulator flying.
                    </p>
                    <p>
                        For the past 15 years I have been helping families to redistribute their loved ones model
                        airplane items. Families really appreciate knowing that the items will be used again and by
                        younger people. I also help modellers to downsize as well. If you have any questions just ask.
                    </p>
                   
                </div>
            </div>
        </div>
        <div class="homepage-contact relative ">
            <div class="container homepage-contact-padding">
                <div class="row">
                    <div class="col-lg-6">
                        <h2 class="space-bottom white">Contact Us For More Info</h2>
                        <p class="white no-bottom">
                            Click the button to visit our contact page if you need to get ahold of us for more
                            information.
                        </p>
                    </div>
                    <div class="col-lg-6 d-flex align-items-center justify-content-lg-end">
                        <router-link to="/about">
                            <div class="button-container space-top-ipad">
                                <div class="standard-button d-flex flex-row">
                                    <div class="cart-left d-flex align-items-center">
                                        <p>Contact Us</p>
                                    </div>
                                    <div class="cart-right d-flex align-items-center justify-content-center">
                                        <ArrowRightIcon :size="100" fillColor="rgb(255,255,255)" />
                                    </div>
                                </div>
                            </div>
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ArrowRightIcon from 'vue-material-design-icons/ArrowRight.vue';
    export default {
        components: {
            ArrowRightIcon
        }
    }
</script>